import { IPaymentTokenAction } from 'actions/paymentTokenActions';
import { LOADING, SUCCESS, ERROR, INIT } from 'utils/asyncStatusHelper';
import { parseTokenParams } from 'actions/PaymentActions/PaymentActions';
import { ITokenVersion, IDcId } from 'typings/Payments/PaymentsTypes';
export const INITIAL_STATE = {
    asyncStatus: INIT,
    tokenVersion: ITokenVersion.V3,
    dcId: IDcId.UNKNOWN_DC,
    error: null
};
export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case IPaymentTokenAction.GET_PAYMENT_TOKEN_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING,
                error: null
            });
        case IPaymentTokenAction.GET_PAYMENT_TOKEN_SUCCESS: {
            const tokenParams = parseTokenParams(action.data.paymentToken);
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                token: action.data.paymentToken,
                callbackUrl: action.data.callbackUrl,
                message: action.data.message,
                tokenVersion: tokenParams.tokenVersion,
                dcId: tokenParams.dcId,
                error: null
            });
        }
        case IPaymentTokenAction.UPDATE_PAYMENT_TOKEN: {
            const tokenParams = parseTokenParams(action.token);
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                token: action.token,
                tokenVersion: tokenParams.tokenVersion,
                dcId: tokenParams.dcId,
                error: null
            });
        }
        case IPaymentTokenAction.GET_PAYMENT_TOKEN_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR,
                error: action.error
            });
        default:
            return state;
    }
}
